import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import withWidth from "@material-ui/core/withWidth/withWidth";
import LinearProgress from "@material-ui/core/LinearProgress";

import { changeAccount, changeCourseID } from "./../redux";
import { anonymousSignIn, searchCourses, signOut } from "./../firebaseApi";
import { Typography, Paper } from "@material-ui/core";

const styles = (theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(2),
    marginTop: theme.spacing(20),
    width: "100%",
    maxWidth: "400px",
    marginLeft: "auto",
    marginRight: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
  button: {
    marginTop: theme.spacing(3),
  },
});

function AnonymousURL(props) {
  React.useEffect(()=> {
    try {
      anonymousSignIn().then((accountDetails) => {
        props.changeAccount(accountDetails);
        let data = { courseCode: props.match.params.courseCode, anonSearch: true };    
        searchCourses(data).then((courses) => {
        
          if (Object.keys(courses).length == 1) {
            props.changeCourseID(Object.keys(courses)[0]);
            let route = "/";
            props.history.push(route);
          } else {
            signOut().then(() => {
              props.changeAccount({});
              let route = "/";
              props.history.push(route);
            });
          }
        });
      });
    } catch (e) {
      console.error(e);
      signOut().then(() => {
        props.changeAccount({});
        let route = "/";
        props.history.push(route);
      });
    }
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Paper className={props.classes.paper}>
        <Typography
          variant="h2"
          style={{
            fontWeight: "bold",
            fontSize: "clamp(2rem, 15vw, 3.8rem)",
          }}
        >
          Webclicker
        </Typography>
        <img
          src={`${process.env.PUBLIC_URL}/free_icon_1.svg`}
          alt="Webclicker Icon"
          style={{
            width: "60px",
            height: "60px",
            marginTop: "10px",
            marginBottom: "30px",
          }}
        />
        <LinearProgress 
          style={{ 
            width: "100%" 
          }}
        />
      </Paper>
    </div>);
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeAccount: (data) => dispatch(changeAccount(data)),
    changeCourseID: (data) => dispatch(changeCourseID(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withStyles(styles, { withTheme: true })(withWidth()(AnonymousURL))));
